import React, {FunctionComponent, memo, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import ContentWrapper from "../../reusable/layout/ContentWrapper";
import SPLoader from "../../reusable/loader/SPLoader";

type Props = {

};

const OAuthCallback: FunctionComponent<Props> = () => {
    const history = useHistory()

    useEffect(() => {
        if (history.location.pathname !== '/callback' || window.location.pathname !== '/callback' ) {
            return;
        }

        (async () => {
            const searchParams = new URLSearchParams(window.location.search)

            const redirectUrl = window.location.href.slice(0, window.location.href.indexOf('?'))
            const resp = await fetch(
                "https://europe-west3-styreportalen-development.cloudfunctions.net/oauth/token",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams({
                        code: searchParams.get("code") ?? '',
                        grant_type: "authorization_code",
                        client_id: 'demo',
                        client_secret: 'a6491cdccddbeae41039chsorvgg3e1285627a25f9158cf9f0dc3ec7ea427',
                        redirect_uri: redirectUrl
                    }).toString(),
                }
            );

            if (!resp.ok) throw new Error(await resp.text());
            const result = await resp.json();

            console.log("RESP", result);

            history.push(`/callback2`, {
                token: result.access_token
            })
        })();
    }, [history])

    return (
        <div className="wrapper">
            <section
                className="select-section-container"
                style={{
                    marginTop: 0,
                }}
            >
                <ContentWrapper>
                    <div
                        className="card w-100"
                        style={{
                            marginTop: "45px",
                        }}
                    >
                        <div
                            className="d-flex flex-column"
                            style={{
                                padding: "1rem 2rem 1rem 2rem",
                                border: "1px solid black",
                            }}
                        >
                            <SPLoader/>
                        </div>
                    </div>
                </ContentWrapper>
            </section>
        </div>
    );
};

export default memo(OAuthCallback);
